<template>
  <div class="filters mt-4">
    <div class="row">
      <div class="col-md-4 mb-4" v-if="taxonomies.sector.length">
        <label for="filter-sector" class="form-label">Sector</label>
        <select class="form-select" aria-label="Sector" id="filter-sector" @change="onFilterChange"
                v-model="filters.sector" name="sector">
          <option selected value="">Select</option>
          <option v-for="option in taxonomies.sector" :value="option.id" v-html="option.name"></option>
        </select>
      </div>
      <div class="col-md-4 mb-4" v-if="taxonomies.type_of_work.length">
        <label for="filter-type-of-work" class="form-label">Type of work</label>
        <select class="form-select" aria-label="Type of work" id="filter-type-of-work" @change="onFilterChange"
                v-model="filters.type_of_work" name="type_of_work">
          <option selected value="">Select</option>
          <option v-for="option in taxonomies.type_of_work" :value="option.id" v-html="option.name"></option>
        </select>
      </div>
      <div class="col-md-4 mb-4" v-if="taxonomies.client.length">
        <label for="filter-client" class="form-label">Client</label>
        <select class="form-select" aria-label="Client" id="filter-client" @change="onFilterChange"
                v-model="filters.client" name="client">
          <option selected value="">Select</option>
          <option v-for="option in taxonomies.client" :value="option.id" v-html="option.name"></option>
        </select>
      </div>
    </div>
  </div>
  <div class="row placeholder-glow" v-if="loading">
    <div class="col-md-4">
      <span class="placeholder bg-secondary col-3 mb-2"></span>
      <span class="h1 placeholder bg-secondary col-12"></span>
    </div>
    <div class="col-md-4">
      <span class="placeholder bg-secondary col-3"></span>
      <span class="h1 placeholder bg-secondary col-12"></span>
    </div>
    <div class="col-md-4">
      <span class="placeholder bg-secondary col-3"></span>
      <span class="h1 placeholder bg-secondary col-12"></span>
    </div>
  </div>
</template>

<script>
import Choices from "choices.js";

export default {
  data() {
    return {
      filters: {
        sector: '',
        type_of_work: '',
        client: ''
      },
      taxonomies: {
        sector: [],
        type_of_work: [],
        client: []
      },
      choices: {},
      loading: false,
      loaded: false,
      choicesInitialized: false
    };
  },
  created() {
    this.loading = true;
    this.fetchData();
  },
  emits: ["filters-updated"],
  methods: {
    setFilters() {
      for (let taxonomy in this.taxonomies) {
        if (this.$route.params[taxonomy].length && this.$route.params[taxonomy] !== "all") {
          for (let i in this.taxonomies[taxonomy]) {
            if (this.taxonomies[taxonomy][i].slug === this.$route.params[taxonomy]) {
              this.filters[taxonomy] = this.taxonomies[taxonomy][i].id;
              // this.choices[taxonomy].setChoiceByValue(this.taxonomies[taxonomy][i].id);
            }
          }
        }
        else {
          // this.choices[taxonomy].setChoiceByValue('');
          this.filters[taxonomy] = '';
        }
      }
      this.$emit("filters-updated", this.collectFilters());
    },
    onFilterChange(event) {
      this.$router.push({ name: 'Home', params: this.getRouteParamsFromFilters() });
    },
    getRouteParamsFromFilters() {
      let params = {}
      for (let taxonomy in this.filters) {
        let id = parseInt(this.filters[taxonomy]);
        if (id > 0) {
          for (let i in this.taxonomies[taxonomy]) {
            if (this.taxonomies[taxonomy][i].id === id) {
              params[taxonomy] = this.taxonomies[taxonomy][i].slug;
            }
          }
        }
        else {
          params[taxonomy] = 'all';
        }
      }
      return params;
    },
    initChoices() {
      document.querySelectorAll('.filters select').forEach(el => {
        this.choices[el.name] = new Choices(el);
      });
      this.choicesInitialized = true;
    },
    fetchData() {

      this.loading = true;
      this.loaded = false;

      let endpoints = [
        '/wp-json/wp/v2/sector',
        '/wp-json/wp/v2/type_of_work',
        '/wp-json/wp/v2/client'
      ];

      const that = this;

      axios.all(endpoints.map((endpoint) => axios.get(endpoint, { params: { per_page: 100 } }))).then(function(responses) {
        that.taxonomies.sector = responses[0].data;
        that.taxonomies.type_of_work = responses[1].data;
        that.taxonomies.client = responses[2].data;
        that.loading = false;
        that.loaded = true;
        that.setFilters();
      }).catch(errors => {
        this.error = 'Filters could not be loaded.';
      })
    },
    collectFilters() {
      let collected = {};
      for (let i in this.filters) {
        if (this.filters[i]) collected[i] = this.filters[i];
      }
      return collected;
    }
  },
  updated: function() {
    if (!this.choicesInitialized) {
      this.initChoices();
    }
  },
  watch: {
    filters: {
      handler(newValue) {
        for (let taxonomy in newValue) {
          if (this.choices[taxonomy]) {
            if (newValue[taxonomy]) {
              this.choices[taxonomy].setChoiceByValue(""+newValue[taxonomy]);
            }
            else {
              this.choices[taxonomy].setChoiceByValue("");
            }
          }

        }
      },
      deep: true
    },
    $route: function(to, from) {
      this.setFilters();
    }
  }
}
</script>
